import LoginComponent from './component'

const Login: React.FC = (): React.ReactElement => {
	return <LoginComponent />
}
export default Login
